import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询
export function queryTaskFunc(data) {
  return request({
    url: URL.sys.automationTask.queryUrl,
    method: 'post',
    data
  })
}

// 检查任务名称是否重复
export function checkTaskNameFunc(data) {
  return request({
    url: URL.sys.automationTask.checkTaskNameUrl,
    method: 'post',
    data
  })
}

// 保存配置
export function saveConfigFunc(data) {
  return request({
    url: URL.sys.automationTask.saveConfigUrl,
    method: 'post',
    data
  })
}

// 删除配置
export function deleteAutoConfigFunc(data) {
  return request({
    url: URL.sys.automationTask.deleteAutoConfigUrl,
    method: 'post',
    data
  })
}

// 复制配置
export function copyConfigFunc(data) {
  return request({
    url: URL.sys.automationTask.copyConfigUrl,
    method: 'post',
    data
  })
}

// 启用/禁用
export function executionTaskFunc(data) {
  return request({
    url: URL.sys.automationTask.executionTaskUrl,
    method: 'post',
    data
  })
}

// 执行历史
export function taskLogFunc(data) {
  return request({
    url: URL.sys.automationTask.taskLogUrl,
    method: 'post',
    data
  })
}

// 推送第三方数据调试接口
export function pushThirdPartyDataDeBugFunc(requestBody) {
  return request({
    url: URL.sys.automationTask.pushThirdPartyDataDeBugFuncUrl,
    method: 'post',
    data: requestBody
  })
}
